// src/components/device/DevicePermissions.jsx
import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Stack,
  FormControlLabel,
  Switch,
  Button,
  Alert,
} from "@mui/material";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export default function DevicePermissions({ device }) {
  // If your backend stores these flags in device.devicePermissions:
  const [permissions, setPermissions] = useState({
    command: device?.devicePermissions?.command ?? true,
    rawCommand: device?.devicePermissions?.rawCommand ?? false,
  });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  const toggle = (key) => (_, checked) => {
    setPermissions((p) => ({ ...p, [key]: checked }));
  };

  const save = async () => {
    setSaving(true);
    setMsg("");
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        `${backendUrl}/device-permissions/${device._id}`,
        permissions,
        { headers: { "x-auth-token": token } }
      );
      setMsg("✅ Permissions updated (audit logged).");
    } catch (e) {
      setMsg(e?.response?.data?.message || "❌ Failed to update permissions");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 640 }}>
      <Card sx={{ borderRadius: 3 }}>
        <CardContent>
          <Stack spacing={1.5}>
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 900 }}>
                Device Permissions
              </Typography>
              <Typography variant="body2" color="text.secondary">
                These flags affect UI + backend authorization for this device.
              </Typography>
            </Box>

            {msg && <Alert severity={msg.startsWith("✅") ? "success" : "error"}>{msg}</Alert>}

            <FormControlLabel
              control={<Switch checked={!!permissions.command} onChange={toggle("command")} />}
              label="Allow Commands"
            />

            <FormControlLabel
              control={<Switch checked={!!permissions.rawCommand} onChange={toggle("rawCommand")} />}
              label="Allow Raw Commands (Dangerous)"
            />

            <Button
              variant="contained"
              onClick={save}
              disabled={saving}
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 900, width: "fit-content" }}
            >
              {saving ? "Saving..." : "Save Permissions"}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
